// extracted by css-extract-rspack-plugin
export default {"backdrop":"BulkDownloadModal-backdrop_QkL","modal":"BulkDownloadModal-modal_rBY"};